import { Injectable } from '@angular/core';
import { map, Subject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Events } from '../Interface/Event';
import { RestService } from './rest-service';
import { Layout } from '../Interface/Layout';

@Injectable({
  providedIn: 'root',
})
export class EventService extends RestService {
  endpoint = `${environment.api}`;
  private _refreshEventList = new Subject<void>();
  private _refreshUserList = new Subject<void>();
  private _refreshImageList = new Subject<void>();
  private _refreshAfterChangeColor = new Subject<void>();
  get refreshAfterChangeColor() {
    return this._refreshAfterChangeColor;
  }
  get refreshEventList() {
    return this._refreshEventList;
  }
  get refreshUserList() {
    return this._refreshUserList;
  }
  get refreshImageList() {
    return this._refreshImageList;
  }
  eventCreate(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-create/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }
  eventDetailsById(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-details-by-id/`,
      formData
    );
  }
  eventUpdate(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/event-update/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }
  updateCustomSettings(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/update-custom-settings/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }
  changeEventChangeImage(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/change-event-change-image/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }
  changeEventFooterTextUpdate(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/change-event-footer-text-update/`,
      formData
    );
  }
  eventList(formData: object, currentPage:number, pageSize:number) {
    return this.http
      .post<Events>(`${this.endpoint}events/all-event-list/?page=${currentPage}&&page_size=${pageSize}`, formData);
  }
  setEvent(formData: object) {
    return this.http
      .post<Events>(`${this.endpoint}events/set-event/`, formData);
  }
  changeLayoutColorSettings(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/change-layout-color-update/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshAfterChangeColor.next();
      })
    );
  }
  updateEventInfo(formData: object) {
    return this.http.put<Layout>(
      `${this.endpoint}events/update-event-info/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }
  eventAssignToUser(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-assign-to-user/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshUserList.next();
      })
    );
  }

  deleteImage(formData: object){
    return this.http.post<Events>(
      `${this.endpoint}events/delete-event-image/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshImageList.next();
      })
    );
  }

  makeEventLiveToClosed(formData: object) {
    return this.http.put<Events>(
      `${this.endpoint}events/make-event-live-to-closed/`,
      formData
    );
  }

  eventClone(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-clone/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshEventList.next();
      })
    );
  }

  eventDelete(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-delete-by-id/`,
      formData
    ).pipe(
      tap(() => {
        this._refreshEventList.next();
      })
    );
  }

  eventArchive(formData: object) {
    return this.http.post<Events>(
      `${this.endpoint}events/event-archive-by-id/`,
      formData
    ).pipe(
      tap(() => {
        this._refreshEventList.next();
      })
    );
  }
}
